module.exports = "mutation ($id: ID!) {\n  ShopDelete(id: $id) {\n    id\n  }\n}\n"